import { DefaultTheme } from 'styled-components'
import { BlogComponentType } from '../types'

export const blogComponentTypeColorMap = ({ theme, component }: { theme: DefaultTheme; component: string }) =>
({
  [BlogComponentType.PRODUCT_NEWS]: theme.colors.turquoise[2],
  [BlogComponentType.COMPANY_INSIGHTS]: theme.colors.fuchsia[2],
  [BlogComponentType.PDF_KNOWLEDGE]: theme.colors.magenta[2],
  [BlogComponentType.USE_CASE]: theme.colors.azure[2],
  [BlogComponentType.CUSTOMER_STORIES]: theme.colors.azure[2],
}[component])

export const PDFToolsTheme: DefaultTheme = {
  shadows: {
    menuOpen:
      '0px 20px 220px -10px rgba(0, 0, 0, 0.1), 0px 12.3603px 90.1397px rgba(0, 0, 0, 0.0325794), 0px 5.13384px 37.4394px rgba(0, 0, 0, 0.025), 0px 1.85681px 13.5411px rgba(0, 0, 0, 0.0174206)',
  },
  colors: {
    white: {
      1: '#fff',
      2: 'rgba(255, 255, 255, .8)',
      3: 'rgba(255, 255, 255, .6)',
      4: 'rgba(255, 255, 255, .4)',
      5: 'rgba(255, 255, 255, .3)',
      6: 'rgba(255, 255, 255, .12)',
      7: '#fff',
    },
    black: {
      1: '#0D0D0D',
      2: '#282724',
      3: '#676765',
      4: '#B5B4B0',
      5: '#DAD9D8',
      6: '#F0F0EF',
      7: '#F8F7F7',
    },
    red: {
      1: '#8E160B',
      2: '#DA1D0B',
      3: '#F54D3D',
      4: '#F7796E',
      5: '#FBBCB6',
      6: '#FDDBD8',
      7: '#FEEDEC',
    },
    none: {
      1: 'transparent',
      2: 'transparent',
      3: 'transparent',
      4: 'transparent',
      5: 'transparent',
      6: 'transparent',
      7: 'transparent',
    },
    azure: {
      1: '#0F558A',
      2: '#0D8FF2',
      3: '#ECF6FE',
      4: '#6EBCF7',
      5: '#B6DDFB',
      6: '#D8EDFD',
      7: '#ECF6FE',
    },
    electricIndigo: {
      1: '#420F8A',
      2: '#620BDA',
      3: '#7B25F4',
      4: '#A666FF',
      5: '#D2B3FF',
      6: '#E7D6FF',
      7: '#F3EBFF',
    },
    bluetiful: {
      1: '#0F398A',
      2: '#0B50DA',
      3: '#0D59F2',
      4: '#6699FF',
      5: '#B3CCFF',
      6: '#D6E4FF',
      7: '#EBF1FF',
    },
    code: {
      text: '#EEFFFF',
      cyan: '#53CCFE',
      green: '#A6E684',
      purple: '#B56AE7',
      red: '#E36D74',
      blue: '#789DEB',
      orange: '#E3AD6D',
    },
    fuchsia: {
      1: '#8A0F75',
      2: '#C20AB3',
      3: '#D50BC4',
      4: '#F76EEC',
      5: '#FBB6F5',
      6: '#FDD8FA',
      7: '#FEECFC',
    },
    limegreen: {
      1: '#0F8A59',
      2: '#0EBE78',
      3: '#10D183',
      4: '#6EF79C',
      5: '#B6FBCD',
      6: '#D8FDE4',
      7: '#ECFEF2',
    },
    green: {
      1: '#0F8A59',
      2: '#0EBE78',
      3: '#10D183',
      4: '#6EF79C',
      5: '#B6FBCD',
      6: '#D8FDE4',
      7: '#ECFEF2',
    },
    magenta: {
      1: '#282724',
      2: '#282724',
      3: '#282724',
      4: '#282724',
      5: '#282724',
      6: '#282724',
      7: '#282724',
    },
    orange: {
      1: '#8A550F',
      2: '#E68200',
      3: '#FFA733',
      4: '#FFBD66',
      5: '#FFDEB3',
      6: '#FFEDD6',
      7: '#FFF6EB',
    },
    turquoise: {
      1: '#0F8A7F',
      2: '#0AC2B2',
      3: '#0BD5C4',
      4: '#6EF7EC',
      5: '#B6FBF5',
      6: '#D8FDFA',
      7: '#ECFEFC',
    },
    yellow: {
      1: '#8A6B0F',
      2: '#E6AC00',
      3: '#FFBF00',
      4: '#FFD966',
      5: '#FFECB3',
      6: '#FFF5D6',
      7: '#FFFAEB',
    },
  },
}
